<script>
	import './index.scss';
	import { pkgBrief } from "../store.js";

	export let index;

	function removeElement(index) {
		$pkgBrief.splice(index, 1);
		$pkgBrief = $pkgBrief;
	}
</script>

<div class="field">
	<label class="label has-text-white">Text <a class="help remove-element" on:click={() => removeElement(index)}>(click to remove)</a></label>
	<div class="control">
		<textarea class="textarea has-text-white has-background-dark" placeholder="Textarea" bind:value={$pkgBrief[index].content}></textarea>
	</div>
</div>